import React from 'react';
import { Button, ButtonProps } from '../Button';

export const RoundButton = (props: ButtonProps) => (
  <Button {...props} sx={{ borderRadius: 100, ...props.sx }} />
);
